import React, {useState} from "react";
import Slider from '@mui/material/Slider';

interface Props {
  onChange: (value:any) => void;
}

const marks = [
  {
    value: 1,
    label: '1',
  },
  {
    value: 50,
    label: '50',
  }
];


export const GroupSizeField: React.ComponentType<Props> = ({onChange}) => {

  return (<>

    <Slider
      sx={{
        '@media (pointer: coarse)': {
          padding: '15px 0 !important',
        },
      }}
      size={'small'}
      defaultValue={10}
      min={1}
      max={50}
      aria-label="Default"
      valueLabelDisplay="auto"
      onChange={(event:any, value)=>{
        onChange(value);
      }}
    />

    {/*<FormControl variant="outlined">
      <InputLabel htmlFor="outlined-adornment-password">Létszám</InputLabel>

      <OutlinedInput
        id="outlined-adornment-password"
        type={'number'}
        fullWidth
        onChange={(event:any)=>{
          onChange(event.target.value);
        }}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label={'display the password'}
              edge="end"
            >
              {<GroupsRounded />}
            </IconButton>
          </InputAdornment>
        }
        label="Létszám"
      />
    </FormControl>*/}
  </>);

}